import { FuseAnimate } from '@fuse';
import _ from '@lodash';
import { Typography, withStyles } from '@material-ui/core';
import XAPPTooltip from 'app/Core/Components/Tooltip/XAPPTooltip';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import classNames from 'classnames';
import React from 'react';
import { BsFillFolderFill } from 'react-icons/bs';
import { FiArrowLeftCircle } from 'react-icons/fi';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/ArquivoActions';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    arquivoItem: {
        transitionProperty: 'box-shadow',
        transitionDuration: theme.transitions.duration.short,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        '&:hover': {
            boxShadow: theme.shadows[5]
        },
    }
});

class PastaList extends XAPPComponent {

    componentDidUpdate(prevProps, prevState) {
        if (this.props.Arquivo.error) {
            this.props.showMessage({
                message: this.props.Arquivo.error,
                variant: 'error'
            });
            this.props.Arquivo.error = null;
        }
        if (this.props.Arquivo.warning) {
            this.props.showMessage({
                message: this.props.Arquivo.warning,
                variant: 'warning'
            });
            this.props.Arquivo.warning = null;
        }
        if (this.props.Arquivo.info) {
            this.props.showMessage({
                message: this.props.Arquivo.info,
                variant: 'success'
            });
            this.props.Arquivo.info = null;
        }
    }

    render() {
        const { classes, setPasta, arquivoState, setPastaOld, Arquivo, tipo = null } = this.props;
        return (
            <React.Fragment>
                {!_.isNull(arquivoState.pasta) &&
                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <div className="flex justify-start flex-wrap">
                            {arquivoState.pasta.split("/").length > 1 &&
                                <div
                                    className={
                                        classNames(
                                            classes.arquivoItem,
                                            "items-center justify-center relative w-96 h-72 rounded-4 ml-8 mb-8 overflow-hidden cursor-pointer")
                                    }
                                    key={arquivoState.pasta}
                                    onClick={() => setPastaOld()}
                                >
                                    <div className="flex flex-col items-center">
                                        <FiArrowLeftCircle className={classNames("text-56")} />
                                    </div>
                                    <Typography className="text-center text-11">
                                        {"Voltar"}
                                    </Typography>
                                </div>
                            }
                            <React.Fragment>
                                {!_.isNull(Arquivo.pastas) && Arquivo.pastas.map(pasta => (
                                    <XAPPTooltip
                                        key={pasta.pasta}
                                        placement="top"
                                        title={pasta.nome}
                                    >
                                        <div
                                            className={
                                                classNames(
                                                    classes.arquivoItem,
                                                    "items-center justify-center relative w-96 h-72 rounded-4 ml-8 mb-8 overflow-hidden cursor-pointer")
                                            }
                                            key={pasta.pasta}
                                            onClick={() => setPasta(pasta.pasta)}
                                        >
                                            <div className="flex flex-col items-center">
                                                <BsFillFolderFill className={classNames("text-56")} />
                                            </div>
                                            <Typography className="text-center text-11">
                                                {pasta.nome.length > 10 ? pasta.nome.substr(0, 10) + ' ...' : pasta.nome}
                                            </Typography>
                                        </div>
                                    </XAPPTooltip>
                                ))}
                            </React.Fragment>
                        </div>
                    </FuseAnimate>
                }
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get,
        list: Actions.list,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Arquivo }) {
    return {
        Arquivo: Arquivo,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PastaList)));
